import { employeeListMiddleware } from './employee-list-middleware';
import { employeeSummaryMiddleware } from './employee-summary-middleware';

export const employeesMiddleware = [
  employeeListMiddleware,
  employeeSummaryMiddleware
];
